import createIcon from '../../createIcon';

/**
 * @component @name Copyright
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuODggOS4xNEMxMy4xNiA5LjIgMTMuNDkgMTAuMjkgMTMuNTEgMTAuOEgxNS4zQzE1LjIyIDguODIgMTMuODEgNy42MSAxMS44NSA3LjYxQzkuNjQgNy42MSA4IDkgOCAxMi4xNEM4IDE0LjA4IDguOTMgMTYuMzggMTEuODQgMTYuMzhDMTQuMDYgMTYuMzggMTUuMjUgMTQuNzMgMTUuMjggMTMuNDNIMTMuNDlDMTMuNDYgMTQuMDIgMTMuMDQgMTQuODEgMTEuODYgMTQuODdDMTAuNTUgMTQuODMgMTAgMTMuODEgMTAgMTIuMTRDMTAgOS4yNSAxMS4yOCA5LjE2IDExLjg4IDkuMTRaTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTIgMjBDNy41OSAyMCA0IDE2LjQxIDQgMTJDNCA3LjU5IDcuNTkgNCAxMiA0QzE2LjQxIDQgMjAgNy41OSAyMCAxMkMyMCAxNi40MSAxNi40MSAyMCAxMiAyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Copyright = createIcon('Copyright', [
  [
    'path',
    {
      d: 'M11.88 9.14C13.16 9.2 13.49 10.29 13.51 10.8H15.3C15.22 8.82 13.81 7.61 11.85 7.61C9.64 7.61 8 9 8 12.14C8 14.08 8.93 16.38 11.84 16.38C14.06 16.38 15.25 14.73 15.28 13.43H13.49C13.46 14.02 13.04 14.81 11.86 14.87C10.55 14.83 10 13.81 10 12.14C10 9.25 11.28 9.16 11.88 9.14ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z',
      key: '1g13k0',
    },
  ],
]);

export default Copyright;
